// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ResetPasswordForm_errorContainer__3ac2w","errorMessage":"ResetPasswordForm_errorMessage__fv7EK"};